import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_mr-2 _tc--light"
}
const _hoisted_2 = { class: "gfu-media__body" }
const _hoisted_3 = { class: "gfu-poll-option__text" }
const _hoisted_4 = { class: "_mr-2 _my-0 _ml-0" }
const _hoisted_5 = {
  class: "gfu-bt gfu-bt--caption",
  "data-qa": "poll-option-vote-label"
}
const _hoisted_6 = { class: "gfu-bt gfu-bt--caption _tc--light" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_progress_bar = _resolveComponent("progress-bar")

  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: _normalizeClass([
           'gfu-poll-option gfu-media',
           {
               'is-muted': $options.isMuted,
               'is-disabled': $options.isDisabled,
               'is-voted': $options.userVotedOption,
               'is-blocked': !$props.canVote
           }
       ]),
    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onClick && $options.onClick(...args)), ["prevent"]))
  }, [
    ($options.showRadio)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_checkbox_field, {
            modelValue: $options.userVotedOption,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.userVotedOption) = $event)),
            type: "radio",
            name: `poll-${$props.pollID}`,
            class: _normalizeClass(['gfu-poll-option__radio', {'is-invisible': $options.cannotVote}])
          }, null, 8 /* PROPS */, ["modelValue", "name", "class"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString($props.text), 1 /* TEXT */),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString($options.voteLabel), 1 /* TEXT */),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("span", _hoisted_6, _toDisplayString($options.voteLabelPercentage), 1 /* TEXT */)
        ])
      ]),
      ($props.isVoteCountVisible)
        ? (_openBlock(), _createBlock(_component_progress_bar, {
            key: 0,
            value: $props.voteCount,
            max: $props.totalVoteCount,
            "progression-class": "gfu-progress-bar__progression--accent gfu-progress-bar--animated-quick"
          }, null, 8 /* PROPS */, ["value", "max"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}